import React, { useEffect, useRef, useState } from 'react';

const MatrixBackground = () => {
  const canvasRef = useRef(null);
  const [overlayOpacity, setOverlayOpacity] = useState(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Character sets
    const katakana = 'アァカサタナハマヤャラワガザダバパイィキシチニヒミリヰギジヂビピウゥクスツヌフムユュルグズブヅプエェケセテネヘメレヱゲゼデベペオォコソトノホモヨョロヲゴゾドボポヴッン';
    const latin = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const nums = '0123456789';
    const alphabet = katakana + latin + nums;

    // Setup
    const fontSize = 16;
    const columns = Math.floor(canvas.width / fontSize);
    const rainDrops = new Array(columns).fill(1);

    // Drawing function
    const draw = () => {
      // Create fade effect with semi-transparent black rectangle
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Set the character style
      ctx.fillStyle = '#0F0';
      ctx.font = `${fontSize}px monospace`;

      // Draw the characters
      for (let i = 0; i < rainDrops.length; i++) {
        // Get a random character from our alphabet
        const text = alphabet[Math.floor(Math.random() * alphabet.length)];
        
        // Draw the character
        const x = i * fontSize;
        const y = rainDrops[i] * fontSize;
        ctx.fillText(text, x, y);

        // Reset drops back to the top with a random chance
        if (y > canvas.height && Math.random() > 0.975) {
          rainDrops[i] = 0;
        }
        
        // Move the raindrop down
        rainDrops[i]++;
      }
    };

    // Animation loop
    const interval = setInterval(draw, 30);

    // Cleanup
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  // Add fade-in effect for overlay
  useEffect(() => {
    const timer = setTimeout(() => {
      setOverlayOpacity(0.7);
    }, 7000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'black',
          opacity: overlayOpacity,
          transition: 'opacity 1s ease-in-out',
          zIndex: 0,
        }}
      />
      <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'black',
        zIndex: -1,
        // opacity: 0.3,
      }}
    />
    </>
  );
};

export default MatrixBackground;
